import axios from 'axios';
import EnvWindow from '../../utils/env';
import { FileTypeE, FinancialReportE } from '../../components/ExamResultsRepository/ExamResultsRepository.types';

export async function exportFinanceReport(examSheetId: string, commiteeId: string, fileType: FileTypeE, settlementOptions: FinancialReportE): Promise<Blob> {
  const response = await axios.post(
    `${EnvWindow.REACT_APP_FINANCE_API_URL}/ExamSheet/${examSheetId}/ExamCommittee/${commiteeId}/FileFormat/${fileType}/settlementOptions/${settlementOptions }`,
  );
  return response.data;
}
